import { connect } from 'react-redux';

import type { AppState } from '../../store/types';
import type { ModalComponentProps } from './modals_manager/types';
import { getModalContextItems, selectOptions } from './selectors';

function mapStateToProps(state: AppState, ownProps: ModalComponentProps) {
  const { modalId } = ownProps;
  // The modal store holds every modal's context items and options in one
  // untyped bag, while each modal declares the shapes it expects through
  // ContextItemsHocProps. FE-7851 tracks keying the store by modal id so the
  // two can be matched; until then this is where the two meet.
  // biome-ignore lint/plugin: see above.
  const items = (getModalContextItems(state, modalId) ?? []) as any;
  return {
    item: items[0],
    items,
    // biome-ignore lint/plugin: see above.
    options: selectOptions(state, modalId) as any,
  };
}

const withContextItems = connect(mapStateToProps);

export default withContextItems;
